// extracted by mini-css-extract-plugin
module.exports = {"tab":"tab-36QJVbj2 clearfix","tg_box":"tg_box-zp9So4lV"};